import React, { useEffect, useState } from 'react'
import classes from './AdminMailingStatuses.module.css'
import { 
    Button, Divider, Flex, Grid, GridItem, Heading, Input, 
    NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, 
    Select, useToast
} from '@chakra-ui/react'
import { useProlongationsStore } from '../../store/prolongationsStore'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import AdminService from '../../API/AdminService'
import { toastError, toastSuccess } from '../../utils/globalHelper'

function AdminMailingStatuses() {
    const toast = useToast()
    const [statuses, setStatuses, fetchStatuses] = useProlongationsStore(
        state => [state.mailingStatuses, state.setMailingStatuses, state.fetchMailingStatuses]
    )

    const [newStatusTitle, setNewStatusTitle] = useState('')
    const [newStatusNumber, setNewStatusNumber] = useState(0)
    const [newStatusGap, setNewStatusGap] = useState(1)

    const [updateStatusNumber, setUpdateStatusNumber] = useState(0)
    const [updateStatusId, setUpdateStatusId] = useState(0)
    const [updateStatuses, setUpdateStatuses] = useState([])
    const [updateNewStatusNumber, setUpdateNewStatusNumber] = useState(0)
    const [updateNewStatusTitle, setUpdateNewStatusTitle] = useState('')
    const [updateNewStatusGap, setUpdateNewStatusGap] = useState(0)

    const [deleteStatusId, setDeleteStatusId] = useState(0)
    const [deleteStatusNumber, setDeleteStatusNumber] = useState(0)
    const [deleteStatuses, setDeleteStatuses] = useState([])

    const createNewStatus = useAccessAPI(AdminService.createMailingStatus)
    const updateStatus = useAccessAPI(AdminService.updateMailingStatus)
    const deleteStatus = useAccessAPI(AdminService.deleteMailingStatus)

    useEffect(() => {
        fetchStatuses()
    }, [])

    useEffect(() => {
        // const tmpStatuses = statuses.filter(s => s.number === updateStatusNumber)
        // setUpdateStatusId(tmpStatuses.length > 0 ? tmpStatuses[0].id : 0)
        // setUpdateStatuses(tmpStatuses)
        // setUpdateNewStatusTitle(tmpStatuses.length > 0 ? tmpStatuses[0].title : '')
        // setUpdateNewStatusGap(tmpStatuses.length > 0 ? tmpStatuses[0].gap : 0)
        setUpdateStatusId(statuses.length > 0 ? statuses[0].id : 0)
        setUpdateStatuses(statuses)
        setUpdateNewStatusTitle(statuses.length > 0 ? statuses[0].title : '')
        setUpdateNewStatusGap(statuses.length > 0 ? statuses[0].gap : 0)
    }, [statuses, updateStatusNumber])

    useEffect(() => {
        // const tmpStatuses = statuses.filter(s => s.number === deleteStatusNumber)
        // setDeleteStatusId(tmpStatuses.length > 0 ? tmpStatuses[0].id : 0)
        // setDeleteStatuses(tmpStatuses)
        setDeleteStatuses(statuses)
    }, [statuses, deleteStatusNumber])

    const onBtnCreateStatus = async () => {
        const response = await createNewStatus(newStatusTitle, newStatusGap)
        if (response?.status === 200) {
            setStatuses([...statuses, response.data])
            toast(toastSuccess(`Статус успешно создан: ${newStatusTitle}`))
            setNewStatusTitle('')
            return
        }
        else if (response?.status === 409) {
            toast(toastError('Ошибка', 'Статус с таким названием уже существует'))
        }
        toast(toastError('Не удалось создать статус'))
    } 

    const onBtnUpdateStatus = async () => {
        const response = await updateStatus(updateStatusId, updateNewStatusTitle, updateNewStatusGap)
        if (response?.status === 200) {
            setStatuses(statuses.map((s) => {
                if (s.id === updateStatusId)
                    return {...s, title: updateNewStatusTitle, gap: updateNewStatusGap}
                return s
            }))
            toast(toastSuccess('Статус успешно обновлён'))
        }
    }

    const onBtnDeleteStatus = async () => {
        const response = await deleteStatus(deleteStatusId)
        if (response?.status === 204) {
            const newStatuseses = statuses.filter(s => s.id !== deleteStatusId)
            setStatuses(newStatuseses)
            // setDeleteStatuses(newStatuses.filter(s => s.number === deleteStatusNumber))
            toast(toastSuccess(`Статус успешно удалён`))
            return
        }
        toast(toastError('Не удалось удалить статус'))
    }

    return (
        <Grid gap="var(--default-gap)">
            <Grid className={classes.blockWrapper}>
                <Heading size='lg' as="h2">Статусы отписок</Heading>
                <Divider/>

                <Heading size='md' as="h3">Создание нового статуса</Heading>
                <Flex gap='var(--default-gap)'>
                    <Select
                        disabled
                        maxW="60px"
                        placeholder='-'
                        value={newStatusNumber}
                        onChange={(e) => setNewStatusNumber(Number(e.target.value))}
                    >
                        {[1, 2, 3].map((number) => (
                            <option value={number} key={`new_status_number${number}`}>{number}</option>
                        ))}
                    </Select>
                    <Input
                        placeholder='Новый статус'
                        value={newStatusTitle}
                        onChange={(e) => setNewStatusTitle(e.target.value)}
                    />
                    <NumberInput
                        maxW='80px'
                        min={0} max={30}
                        value={newStatusGap}
                        onChange={(value) => setNewStatusGap(Number(value))}
                    >
                        <NumberInputField />
                        <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                        </NumberInputStepper>
                    </NumberInput>
                    <Button
                        minW='120px'
                        onClick={onBtnCreateStatus}
                        isDisabled={/* newStatusNumber < 1 || */ newStatusTitle.length < 4}
                    >
                        Создать
                    </Button>
                </Flex>
                <Divider/>

                <Heading size='md' as="h3">Обновление статуса</Heading>
                <Grid className={classes.updateForm}>
                    <Select
                        disabled
                        maxW="60px"
                        placeholder='-'
                        value={updateStatusNumber}
                        onChange={(e) => {
                            const number = Number(e.target.value)
                            setUpdateStatusNumber(number)
                            setUpdateNewStatusNumber(number)
                        }}
                    >
                        {[1, 2, 3].map((number) => (
                            <option value={number} key={`upd_status_number${number}`}>{number}</option>
                        ))}
                    </Select>
                    <Select
                        placeholder='-'
                        value={updateStatusId}
                        onChange={(e) => {
                            const id = Number(e.target.value)
                            setUpdateStatusId(id)
                            setUpdateNewStatusTitle(updateStatuses.find(s => s.id === id)?.title || '')
                            setUpdateNewStatusGap(updateStatuses.find(s => s.id === id)?.gap || 0)
                        }}
                    >
                        {updateStatuses.map((status) => (
                            <option value={status.id} key={`upd_status${status.id}`}>{status.title}</option>
                        ))}
                    </Select>
                    <NumberInput
                        maxW='80px'
                        isReadOnly={true}
                        value={updateStatusId ? statuses.find(s => s.id === updateStatusId)?.gap : 0}
                        onChange={(e) => console.log(e)}
                    >
                        <NumberInputField />
                    </NumberInput>
                    <GridItem rowSpan={2} display='grid' alignItems='end'>
                        <Button
                            minW='120px'
                            onClick={onBtnUpdateStatus}
                            isDisabled={!updateStatusId}
                            alignSelf='end'
                        >
                            Обновить
                        </Button>
                    </GridItem>
                    <Select
                        disabled
                        maxW="60px"
                        placeholder='-'
                        value={updateNewStatusNumber}
                        onChange={(e) => setUpdateNewStatusNumber(Number(e.target.value))}
                    >
                        {[1, 2, 3].map((number) => (
                            <option value={number} key={`upd_new_status_number${number}`}>{number}</option>
                        ))}
                    </Select>
                    <Input
                        placeholder='Обновленный статус'
                        value={updateNewStatusTitle}
                        onChange={(e) => setUpdateNewStatusTitle(e.target.value)}
                    />
                    <NumberInput
                        maxW='80px'
                        min={0} max={30}
                        value={updateNewStatusGap}
                        onChange={(value) => setUpdateNewStatusGap(Number(value))}
                    >
                        <NumberInputField />
                        <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                        </NumberInputStepper>
                    </NumberInput>
                </Grid>
                <Divider/>

                <Heading size='md' as="h3">Удаление статуса</Heading>
                <Flex gap="var(--default-gap)">
                    <Select
                        disabled
                        maxW="60px"
                        placeholder='-'
                        value={deleteStatusNumber}
                        onChange={(e) => setDeleteStatusNumber(Number(e.target.value))}
                    >
                        {[1, 2, 3].map((number) => (
                            <option value={number} key={`del_status_number${number}`}>{number}</option>
                        ))}
                    </Select>
                    <Select
                        placeholder='-'
                        value={deleteStatusId}
                        onChange={(e) => setDeleteStatusId(Number(e.target.value))}
                    >
                        {deleteStatuses.map((status) => (
                            <option value={status.id} key={`del_status${status.id}`}>{status.title}</option>
                        ))}
                    </Select>
                    <Button
                        minW='120px'
                        onClick={onBtnDeleteStatus}
                        isDisabled={deleteStatusId < 1}
                    >
                        Удалить
                    </Button>
                </Flex>
            </Grid>
        </Grid>
    )
}

export default AdminMailingStatuses
